import React from "react";
import { Button } from "antd";
import { IDocumentsDownloadProps } from "../../../../interfaces/Ui/Documents/DocumentsDownload/IDocumentsDownloadProps";
import { SigningStatusDocument } from "./SigningStatusDocument/SigningStatusDocument";
import { DownloadOutlined } from "@ant-design/icons";
import classes from "./DocumentItemDownloadUI.module.css";
import { DocumentItemUI } from "../DocumentItemUI/DocumentItemUI";

export const DocumentItemDownloadUI = ({
  title,
  subtitle,
  downloadButtonProps,
  signingStatus,
  onDownload,
  className,
  hideSigningStatus = false,
  childrenSigningStatus,

  ...restProps
}: IDocumentsDownloadProps) => {
  const concatClassName = `${className ? className : ""} ${
    classes.downloadDocument
  }`;

  const concatClassNameDownloadButton = `${
    downloadButtonProps?.className ? downloadButtonProps.className : ""
  } ${classes.downloadButton}`;
  return (
    <DocumentItemUI
      className={concatClassName}
      title={title}
      subtitle={subtitle}
      documentInfoContainerProps={{ className: classes.documentInfo }}
      {...restProps}
    >
      <div className={classes.documentAddContent}>
        {!hideSigningStatus && (
          <SigningStatusDocument status={signingStatus}>
            {childrenSigningStatus}
          </SigningStatusDocument>
        )}

        <Button
          variant="text"
          color="default"
          shape="circle"
          size="small"
          onClick={onDownload}
          {...downloadButtonProps}
          className={concatClassNameDownloadButton}
        >
          {downloadButtonProps?.children ? (
            downloadButtonProps?.children
          ) : (
            <DownloadOutlined className={classes.downloadIcon} />
          )}
        </Button>
      </div>
    </DocumentItemUI>
  );
};
